var map = {
	"./ab_im.jpg": 6205,
	"./about_left.png": 5470,
	"./accessibility.svg": 7338,
	"./ajax-loader.gif": 586,
	"./amb_cover_3.jpeg": 9379,
	"./amb_cover_4.jpeg": 9539,
	"./amb_obl.jpg": 7771,
	"./amba_cover_2.jpeg": 2553,
	"./arrow_1.svg": 2040,
	"./arrow_2.svg": 1297,
	"./arrow_3.svg": 5454,
	"./ava_img.jpg": 2870,
	"./birds_1.svg": 4725,
	"./birds_2.svg": 856,
	"./bottom_stats_im0.png": 4188,
	"./chat_im.svg": 6095,
	"./cheb.jpg": 100,
	"./copy_img.png": 1386,
	"./default_ambassador_avatar.jpeg": 695,
	"./default_ambassador_background.jpg": 5489,
	"./dorm_placeholder.jpg": 7653,
	"./falk_.png": 1924,
	"./falk_square.jpg": 5507,
	"./fl_3.png": 1287,
	"./flying_image_0.png": 4873,
	"./flying_image_1.png": 8735,
	"./flying_image_2.png": 1212,
	"./flying_image_3.png": 1530,
	"./group_people.png": 9800,
	"./icn.svg": 304,
	"./iiim.png": 3783,
	"./im_00_1.png": 7825,
	"./im_00_3.png": 8832,
	"./image_circle_01.png": 1259,
	"./img_00_2.png": 5807,
	"./img_g_1.png": 9313,
	"./kaz_top.jpg": 7337,
	"./kireev.jpeg": 4959,
	"./kul_01.jpg": 5686,
	"./left_boxes_images.svg": 577,
	"./left_boxes_images_2.svg": 2678,
	"./lo_1.png": 1139,
	"./lo_2.png": 9773,
	"./lo_3.png": 7142,
	"./location_city.png": 9302,
	"./location_city.svg": 5019,
	"./logo-mountain.svg": 986,
	"./logo.svg": 2835,
	"./logo_01.svg": 9820,
	"./logo_new.svg": 4000,
	"./logo_new_1.svg": 514,
	"./logo_new_11.svg": 9534,
	"./logo_new_2.svg": 5291,
	"./main_23.jpg": 4212,
	"./map_pp.jpg": 8536,
	"./minobr_logo.png": 3678,
	"./miobr_logo.svg": 5773,
	"./mmc_left.svg": 9321,
	"./mmc_left_2.svg": 7738,
	"./mmc_logo.png": 6268,
	"./mmc_logo.svg": 2865,
	"./mmc_right.svg": 2807,
	"./mmc_right_2.svg": 3371,
	"./nek.jpg": 5204,
	"./nek22.jpg": 5501,
	"./no_face.png": 4047,
	"./np_01.jpg": 8990,
	"./obl_2.jpg": 1797,
	"./paper-plane.png": 947,
	"./pdf.svg": 6753,
	"./photo_big_02.jpeg": 8023,
	"./prob_01.jpg": 6106,
	"./prof_01.jpg": 8493,
	"./rect_01.jpg": 178,
	"./rect_02.jpg": 8128,
	"./rect_03.jpg": 8975,
	"./rf_rf.jpeg": 8711,
	"./ru_map.svg": 5145,
	"./russ_map.jpg": 7767,
	"./share.png": 7317,
	"./spinner.svg": 8894,
	"./st_p.png": 7380,
	"./st_p_1.png": 3718,
	"./star.svg": 3111,
	"./stud_im.png": 8588,
	"./tg_button.svg": 9328,
	"./top/001.jpg": 3573,
	"./top/002.jpg": 3201,
	"./top/003.jpg": 5685,
	"./top/004.jpg": 4177,
	"./top/005.jpg": 3459,
	"./top/007.jpg": 2699,
	"./top/008.jpg": 6135,
	"./top/009.jpg": 2793,
	"./top/010.jpg": 7216,
	"./top/011.jpg": 1717,
	"./top/012.jpg": 5708,
	"./top/top_01.jpg": 3531,
	"./top/top_02.jpg": 9659,
	"./top/top_03.jpg": 745,
	"./top/top_04.jpg": 8053,
	"./top/top_05.jpg": 1010,
	"./top_ccc_kaz.jpg": 1810,
	"./top_stats_im0.png": 5706,
	"./university.png": 8570,
	"./university_2.png": 981,
	"./vk_button.svg": 6556,
	"./x.svg": 1275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;